// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"playlist-card-skeleton_Wrapper__xdiUv","Title":"playlist-card-skeleton_Title__8fESY","Amount":"playlist-card-skeleton_Amount__jolaS"};